import { render } from "./MenuResultatsSurface.vue?vue&type=template&id=1f81116b"
import script from "./MenuResultatsSurface.vue?vue&type=script&lang=js"
export * from "./MenuResultatsSurface.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__